import { normalizeSort } from '../utils'
import LocationService from '../services/LocationService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['date_inicial'],
    sortDesc: [false]
  }
})

const getters = {
  LOCATIONS: state => {
    return state.list
  },
  LOCATIONS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_LOCATIONS: (state, payload) => {
    state.list = payload
  },
  SET_LOCATIONS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_LOCATION: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_LOCATION: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_LOCATION: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_LOCATION: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_LOCATIONS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc),
        'expand': 'dealer,dealers,estadoProcesos' // Incluir dealer, dealers asignados (compartidas) y estado de proceso
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }
      let { data, status } = await LocationService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        commit('SET_LOCATIONS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de Locations')
      console.error(error)
    }
  },
  LOAD_ALL_LOCATIONS: async ({ commit }) => {
    try {
      let { data, status } = await LocationService.getAll()
      if (status === 200) {
        commit('SET_LOCATIONS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de ubicaciones')
      console.error(error)
    }
  },
  VIEW_LOCATION: async (obj, params) => {
    try {
      params.expand = 'dealer,estadoProcesos' // Incluir información del dealer y estado de proceso
      let { data, status } = await LocationService.view(params)
      if (status === 200) {
        return data.data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles de los Locations')
    }
  },
  ADD_LOCATION: async ({ commit }, payload) => {
    try {
      let { data, status } = await LocationService.post(payload)
      if (status === 201) {
        commit('ADD_LOCATION', data)
        window.app.$toast.success('El Location ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_LOCATION: async ({ commit }, payload) => {
    try {
      let { data, status } = await LocationService.put(payload)
      if (status === 200) {
        commit('UPDATE_LOCATION', data.data)
        window.app.$toast.success('El Location ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_LOCATION: async ({ commit }, payload) => {
    try {
      let { status } = await LocationService.delete(payload)
      if (status === 204) {
        commit('DELETE_LOCATION', payload)
        // No mostrar toast aquí, lo hará el componente
      }
    } catch (error) {
      console.error('Error al eliminar ubicación:', error)
      // Propagar el error para que el componente lo maneje
      throw error
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
